import { Modal, Toast } from "antd-mobile";
import { getStrFun } from "./util";

/** sessionStorage 中的 token 备份键（与 localStorage my_token 区分；关标签页即清空） */
export const AUTH_SESSION_TOKEN_KEY = "my_session_token";

let loginFailModalOpen = false;

const readReloadCount = () => {
  const now = Date.now();
  const windowStart = parseInt(localStorage.getItem("login_reload_window_start") || "0", 10) || 0;
  // 超过 5 分钟，计数清零重新计
  if (!windowStart || now - windowStart > 5 * 60 * 1000) {
    localStorage.setItem("login_reload_window_start", String(now));
    localStorage.setItem("login_reload_count", "0");
    return 0;
  }
  return parseInt(localStorage.getItem("login_reload_count") || "0", 10) || 0;
};

/** 登录成功后清零 reload 计数 */
export function resetLoginReloadCount() {
  try {
    localStorage.removeItem("login_reload_count");
    localStorage.removeItem("login_reload_window_start");
    sessionStorage.removeItem("login_reload_pending");
  } catch (e) {}
}

/**
 * 登录失败尝试 reload：5 分钟内最多 3 次，超限则不再 reload
 * @returns {boolean} 是否已触发 reload
 */
export function tryReloadAfterLoginFail() {
  try {
    if (sessionStorage.getItem("login_reload_pending") === "1") {
      return false;
    }
    const count = readReloadCount();
    if (count >= 3) {
      console.warn("[auth] 5 分钟内 reload 已达 3 次，停止刷新");
      return false;
    }
    localStorage.setItem("login_reload_count", String(count + 1));
    sessionStorage.setItem("login_reload_pending", "1");
    window.location.reload();
    return true;
  } catch (e) {
    return false;
  }
}

/** 登录失败弹窗（全局去重）；点确定后尝试 reload，超限则 Toast */
export function promptLoginFailReload() {
  if (loginFailModalOpen) return;
  loginFailModalOpen = true;
  Modal.alert({
    content: getStrFun("logfail", "Login failed"),
    confirmText: getStrFun("iknowbtn", "OK"),
    onConfirm: () => {
      loginFailModalOpen = false;
      if (!getClientAuthToken() && !tryReloadAfterLoginFail()) {
        Toast.show({ content: getStrFun("logfail", "Login failed") });
      }
    },
  });
}

/** 与 localStorage / window 同步写入 sessionStorage，供 getClientAuthToken 第三顺位读取 */
export function setSessionAuthToken(token) {
  try {
    if (typeof sessionStorage === "undefined") return;
    token = token == null ? "" : String(token);
    sessionStorage.setItem(AUTH_SESSION_TOKEN_KEY, String(token));
  } catch (e) {}
}

/** 前端可用的登录态：localStorage -> 内存 → sessionStorage（同标签会话内） */
export function getClientAuthToken() {
  try {
    return (
      localStorage.getItem("my_token") || (window &&window.__my_token__) ||
      (sessionStorage && sessionStorage.getItem(AUTH_SESSION_TOKEN_KEY)) ||
      ""
    );
  } catch (e) {
    return "";
  }
}
